"use client";
import React from "react";
import { Logo } from "../types/synergyTypes";
import Marquee from "@/components/marketing/magic-ui/marquee";

interface TrustedByProps {
  title: string;
  logos: Logo[];
}

const TrustedBy: React.FC<TrustedByProps> = ({ title, logos }) => {
  return (
    <section className="bg-white py-8 overflow-hidden">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-center items-center px-4">
        <p className="w-full md:w-2/4 text-center md:text-left font-bold text-black text-md mb-6 md:mb-0">
          {title}
        </p>
        <div className="relative w-full md:w-3/4">
          {/* Gradient overlays for fade effect */}
          <div className="absolute left-0 top-0 bottom-0 w-12 md:w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-12 md:w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

          {/* Marquee component */}
          <Marquee
            pauseOnHover
            className="[--duration:25s] [--gap:3rem]"
            repeat={4}
          >
            {logos.map((logo, index) => (
              <img
                key={`${logo.alt}-${index}`}
                src={logo.src}
                alt={logo.alt}
                className="w-auto h-8 md:h-10"
                loading="lazy"
              />
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
